import React from 'react'
import * as Yup from 'yup';
import { useState, useEffect } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider, FieldArray, getIn } from 'formik';
import { connect } from "react-redux";
import { Icon } from '@iconify/react';
import eyeFill from '@iconify/icons-eva/eye-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';
import { DropzoneArea } from "material-ui-dropzone";
// material
import {
    Link,
    Card,
    Stack,
    Checkbox,
    TextField,
    IconButton,
    InputAdornment,
    FormControlLabel,
    Container,
    Typography,
    TableContainer,
    Table,
    TableBody,
    TableRow,
    TableCell,
    TablePagination,
    Grid,
    Button,
    TextareaAutosize
} from '@mui/material';
import { ListHead, ListToolbar, MoreMenu } from '../../components/_dashboard/car';
import { LoadingButton } from '@mui/lab';
import Scrollbar from '../../components/Scrollbar';
import { createAgreement } from '../../actions/agreementAction';
import _ from 'lodash';
import Page from '../../components/Page';
import { styled } from '@mui/material/styles';
import Edit from "@material-ui/icons/Edit";
import DeleteOutlined from "@material-ui/icons/DeleteOutlined";
import ModalCompoennt from '../Portal/ModalCompoennt';

function ViewCarDetails(props) {
    return (
        <Page title="View Car Details">
            <Container maxWidth="lg">
                <Card sx={{padding:"1em"}}>
                    <Stack sx={{ mb: 5 }}>
                        <Typography sx={{ color: 'text.secondary' }} gutterBottom>Car Details</Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <b>Car Name:</b> {!_.isEmpty(props.carObj.carObj) && props.carObj.carObj.motor}
                            </Grid>
                            <Grid item xs={6}>
                                <b>Chasis No:</b> {!_.isEmpty(props.carObj.carObj) && props.carObj.carObj.chasis_no}
                            </Grid>
                            <Grid item xs={6}>
                                <b>Engine No:</b> {!_.isEmpty(props.carObj.carObj) && props.carObj.carObj.engine_no}
                            </Grid>
                            <Grid item xs={6}>
                                <b>Registration No:</b> {!_.isEmpty(props.carObj.carObj) && props.carObj.carObj.reg_no}
                            </Grid>
                        </Grid>
                    </Stack>
                </Card>
            </Container>
        </Page>
    );
}

export default ViewCarDetails;
